import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  IconCollection,
  IconProfileCard,
  LayoutSingleColumn,
  Modal,
  Page,
  Skeleton,

} from '../../../components';
import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import css from './FavouritePage.module.css'
import { isScrollingDisabled, manageDisableScrolling } from '../../../ducks/ui.duck';
import RuleBooksCards from '../RuleBooksCards/RuleBooksCards';
import { addOrRemoveFavChats } from '../RuleBooksSearchPage.duck';
import { FormattedMessage, useIntl } from 'react-intl';
import Spinner from '../../../components/IconSpinner/IconSpinner';
import Slider from 'react-slick';
import classNames from 'classnames';

import {

  communityPostAccess,
  EXPLORE,
  NOTIFICATION,
  REQUEST_RULEBOOK_TEMPLATE_ID,
  SIGNUP_TAB_DETAIL,
} from '../../../util/types';
import { useHistory, useLocation } from 'react-router-dom';
import { createResourceLocatorString } from '../../../util/routes';
import PaginationMyActivity from '../../CircleCommunityPage/components/MyActivity/PaginationMyActivity';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';

import RequestRuleBookForm from '../../PageBuilder/SectionBuilder/SectionHero/RequestRuleBookForm';
import { onSingleMailApiCollection } from '../../../util/api';
// import { currentUserRole, getUserPermissions } from '../../../util/data';
import { setElephantVerificationModal, subscriptionPermissionRequest } from '../../../ducks/user.duck';
import CreatePostBar from '../../CircleCommunityPage/components/CreatePostBar/CreatePostBar';
import NotificationMobileModal from '../../../components/NotificationDropdown/NotificationMobileModal';
import { advancedSearch, createSpacePost, getNotificationPreference, getNotificationsList, markAllNotificationsAsRead, markNotificationAsRead, toggleCreatePost, updateNotificationPreference } from '../../CircleCommunityPage/CircleCommunityPage.duck';
import SideBar from '../FeedTabs/SideBar/SideBar';
import ChatBotSideBar from '../../AiChatBotPage/ChatBotSideBar/ChatBotSideBar';
import { checkElephantModalOpen, currentUserRole, getUserPermissions } from '../../../util/data';
import { toastifyFn } from '../../../components/ReactToastify/ReactToastify';
import { openIntecomOnClickEvents } from '../../../components/IntercomComponent/IntercomComponent';
import MobileBottomTabs from '../../CircleCommunityPage/components/MobileBottomTabs/MobileBottomTabs';


const FavouritePage = props => {
  const history = useHistory();
  const intl = useIntl();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const [searchValue, setSearchValue] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('rulebook') || '';
  });
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [requestRuleBookModal, setRequestRuleBook] = useState({
    isModalOpen: false,
    inProgress: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const favouritesRef = useRef(null);

  const {
    currentUser,
    scrollingDisabled,
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError,
    onManageDisableScrolling,
    onToggleCreatePost,
    onFetchNotifications,
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onMarkNotificationRead,
    onGetNotificationPreference,
    onUpdateNotificationPreference,
    onMarkAllNotificationsAsRead,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData,
    onSubscriptionPermissionRequest,
    onAdvancedSearch,
    params,
    onCreateSpacePost,
    onSetElephantVerificationModal,
    ...rest
  } = props;

  const isOpenElephantModal = checkElephantModalOpen(currentUser);
  const userSubscriptionRole = currentUserRole(currentUser);
  const checkCreatePostAuth = getUserPermissions(userSubscriptionRole, communityPostAccess);
  // useEffect(() => {

  //   setTimeout(() => {
  //     if (params?.rulebookId === 'favourites' && favouritesRef.current) {
  //       window.scrollTo({
  //         top: favouritesRef.current.offsetTop - 100, // Adjust the offset value to make the position more top
  //         behavior: 'smooth'
  //       });
  //     }
  //   }, 1000)
  // }, [params, fetchChatInProgress]);
  // Extract page number from URL query parameters

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const page = parseInt(searchParams.get("page")) || 1; // Default to page 1 if not found
    setCurrentPage(page);
    setSearchValue(searchParams.get('rulebook') || '');
  }, [location.search]);

  const handleIconClick = content => {
    const { tab, pageName, params } = content;

    if (tab === 'MENU') {
      setIsSideBarOpen(tab);
    } else if (tab === 'ADD_MENU') {

      if (isOpenElephantModal && !isCreatePost) {
        onSetElephantVerificationModal(true);
        return;
      };

      if (!checkCreatePostAuth) {
        onSubscriptionPermissionRequest(true);
        return;
      }
      onToggleCreatePost(true);
    }

    else if (tab == "SUPPORT") {
      openIntecomOnClickEvents();
      return;
    }
    else {
      return pageName && history.push(createResourceLocatorString(pageName, routeConfiguration, params, {}))
    }


    // else if (tab === EXPLORE) {
    //   window.location.href = '/feed-page/group-search';
    // } else if (tab === NOTIFICATION) {
    //   setIsOpen(true);
    // }
  };

  const closeSideBar = () => {
    setIsSideBarOpen(false);
  };

  const scrollToSection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentUser?.id?.uuid) {
      if (!currentUser?.attributes?.emailVerified) {
        return history.push(createResourceLocatorString("SignUpStepsPage", routeConfiguration, { tab: SIGNUP_TAB_DETAIL }, {}));
      };
      setRequestRuleBook({
        ...requestRuleBookModal,
        isModalOpen: true
      })
    }
  };


  const mobileBottomTabsComponent = <MobileBottomTabs currentUser={currentUser} handleIconClick={handleIconClick} selectedTab={"TURNOUTAI"} />;

  const { favGpt = [], gpts = [] } = userFavChatDetails || {};

  const favFileIds = favGpt?.map((chat) => chat.rulebook_id) || [];
  const favChats = gpts?.filter((e) => favFileIds?.includes(e.rulebook_id)) || [];
  // const { currentPage, pageSize, totalPages, totalRecords } = gptsDetails || {};

  const onSubmit = async (values, form) => {
    setRequestRuleBook((prevState) => ({ ...prevState, inProgress: true }));

    try {
      const { email, profile } = currentUser?.attributes || {};
      const { firstName = '', lastName = '' } = profile || {};

      const data = {
        ...values,
        userName: `${firstName} ${lastName}`,
        userEmail: email,
        email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
        name: process.env.REACT_APP_SENDGRID_SENDER_NAME,
        userId: currentUser?.id?.uuid,
        groupName: values.rulebookName,
        viewRequestURL: ""
      };

      await onSingleMailApiCollection({
        data,
        template_id: REQUEST_RULEBOOK_TEMPLATE_ID,
      });

      toastifyFn('success', intl.formatMessage({ id: 'RequestRulebookForm.submitSuccess' }));
    } catch (error) {
      console.error('Error submitting request rulebook:', error);
      toastifyFn('error', intl.formatMessage({ id: 'RequestRulebookForm.submitError' }));
    } finally {
      setRequestRuleBook({ isModalOpen: false, inProgress: false });
    }
  };

  const NotificationMobileComponent = (
    <NotificationMobileModal
      onFetchNotifications={onFetchNotifications}
      requestNotificationsInProgress={requestNotificationsInProgress}
      notificationsData={notificationsData}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      onMarkNotificationRead={onMarkNotificationRead}
      onManageDisableScrolling={onManageDisableScrolling}
      requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
      notificaitonPreferenceData={notificaitonPreferenceData}
      onGetNotificationPreference={onGetNotificationPreference}
      onUpdateNotificationPreference={onUpdateNotificationPreference}
      onMarkAllNotificationsAsRead={onMarkAllNotificationsAsRead}
      currentUser={currentUser}
    />
  );

  const handlePostCreation = async (apiParams, spaceId, postId) => {
    const response = await onCreateSpacePost(apiParams, spaceId, postId)
    if (response?.id) {
      return history.push(
        createResourceLocatorString(
          'PostViewPage',
          routeConfiguration,
          { spaceId, slug: response?.slug, postId: response?.id },
        )
      );
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 12; // Number of items per page
  const totalPages = Math.ceil(favChats.length / pageSize);
  // Compute paginated data
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const paginatedFavChats = favChats.slice(indexOfFirstItem, indexOfLastItem);
  const searchRulebooks = () => {
    const rulebook = searchValue?.trim();
    history.push(
      createResourceLocatorString('FavouritePage', routeConfiguration, { rulebookId: 'favourites' }, {
        page: 1,
        ...(rulebook ? { rulebook } : {}),
      })
    );
  };


  return (
    <Page scrollingDisabled={scrollingDisabled} className={css.pageRoot}>
      <LayoutSingleColumn
        className={css.pageWrapper}
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              currentPage={"FavouritePage"}
            />
          </>
        }
      >
        <div className={css.container}>
          <div className={classNames(css.sidebar, isSideBarOpen && css.sidebarOpen)}>

            <ChatBotSideBar
              currentPage={'AiChatBotPage'}
              gptsDetails={gptsDetails}
              fetchChatInProgress={fetchChatInProgress}
              chatDetails={chatDetails}
              fetchChatError={fetchChatError}
              isSideBarOpen={isSideBarOpen}
              userFavChatDetails={userFavChatDetails}
              scrollToSection={scrollToSection}
              params={params}
              currentUser={currentUser}
            />
          </div>

          <div className={css.chatSection}>
            <div className={css.headerContainer}>
              {(currentUser && currentUser?.id?.uuid) ? <h4 className={css.title}><FormattedMessage id="RuleBooksSearchPage.favHeading" /></h4> : null}
              <div className={css.searchContainer}>
                <span className={css.icon} onClick={searchRulebooks}>
                  <IconCollection name="iconSearch" />
                </span>
                <input
                  type="text"
                  placeholder="Search by rulebook"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      searchRulebooks();
                    }
                  }}
                />
              </div>
            </div>

            {fetchChatInProgress ? (
              <div className={css.noResultFound}>
                <Skeleton AiChatBot={true} height={387} width={357} />
              </div>
            ) :
              (currentUser && currentUser?.id?.uuid) ? (
                <div id="favourites" ref={favouritesRef}>
                  {(paginatedFavChats && paginatedFavChats.length > 0) ? (
                    <>
                      <div className={css.cardGridWrapper} >
                        {paginatedFavChats?.map((rulebooks, index) => (
                          <div key={index}>
                            <RuleBooksCards
                              {...rest}
                              currentUser={currentUser}
                              rulebooks={rulebooks}
                              favFileIds={favFileIds}
                              history={history}
                              routeConfiguration={routeConfiguration}
                            />
                          </div>
                        ))}

                      </div>

                      {/* Add pagination for favourites */}
                      {totalPages > 1 && <div className={css.paginationContainer}>
                        {/* Pagination Component */}
                        <PaginationMyActivity
                          currentPage={currentPage}
                          hasNextPage={currentPage < totalPages}
                          onPageChange={(page) => {
                            setCurrentPage(page);
                            history.push(createResourceLocatorString('FavouritePage', routeConfiguration, { rulebookId: params?.rulebookId }, {
                              page,
                              ...(searchValue ? { rulebook: searchValue } : {}),
                            }))
                          }}
                          posts_count={favChats.length}
                          per_page={pageSize}
                          isActiveTab={'documents'}
                        />
                      </div>}

                    </>
                  ) : fetchChatError || fetchAllGptsError ? (
                    <div className={css.noResultFound}>
                      <FormattedMessage id="RuleBooksSearchPage.failedToLoad" />
                    </div>
                  ) : (
                    <div className={css.noResultFound}>
                      <FormattedMessage id="RuleBooksSearchPage.noFavResultFound" />
                    </div>
                  )}
                </div>
              ) : null}

          </div>
        </div> 
        {currentUser && currentUser?.id ? mobileBottomTabsComponent : null}
        <SideBar
          isOpen={isSideBarOpen}
          onClose={closeSideBar}
          currentPage={'AiChatBotPage'}
          gptsDetails={gptsDetails}
          fetchChatInProgress={fetchChatInProgress}
          chatDetails={chatDetails}
          fetchChatError={fetchChatError}
          isSideBarOpen={isSideBarOpen}
          userFavChatDetails={userFavChatDetails}
          scrollToSection={scrollToSection}
          favChats={favChats}
          currentUser={currentUser}
        />

        <Modal
          id="RequestRulebookModal.SectionHero"
          isOpen={requestRuleBookModal.isModalOpen}
          onClose={() => setRequestRuleBook({
            isModalOpen: false,
            inProgress: false,
            isError: null
          })}
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.mobileNotificationModal}
        >
          <div>
            <div className={css.headingWrapper}>
              <h1>{intl.formatMessage(
                { id: 'RequestRulebookModal.requestRulebook' }
              )}</h1>

              <h3>
                <IconProfileCard type='info' />
                {intl.formatMessage(
                  { id: 'RequestRulebookModal.requestRulebookSub' }
                )}</h3>
            </div>

            <RequestRuleBookForm
              onSubmit={(values, form) => onSubmit(values, form)}
              inAddUpdateProgress={requestRuleBookModal.inProgress}
              intl={intl}
            />
          </div>
        </Modal>
        {NotificationMobileComponent}

        {isCreatePost ? (
          <div>
            <CreatePostBar
              requestDirectUpload={requestDirectUpload}
              currentCommunityMember={currentCommunityMember}
              spaceListData={spaceListData}
              onCreateSpacePost={handlePostCreation}
              isCreatePost={isCreatePost}
              onToggleCreatePost={value => {
                if (isOpenElephantModal && !isCreatePost) {
                  onSetElephantVerificationModal(true);
                  return;
                };

                checkCreatePostAuth
                  ? onToggleCreatePost(value)
                  : onSubscriptionPermissionRequest(true);
              }}
              onAdvancedSearch={onAdvancedSearch}
              advancedSearchData={advancedSearchData}
              params={params}
              currentUser={currentUser}
            />
          </div>
        ) : null}

      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError
  } = state.RuleBooksSearchPage;
  const { currentUser } = state.user;
  const {
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData
  } = state.CircleCommunityPage;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError,
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData

  };
};
const mapDispatchToProps = dispatch => ({
  onAddOrRemoveFavChats: (params) => dispatch(addOrRemoveFavChats(params)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onToggleCreatePost: value => dispatch(toggleCreatePost(value)),
  onFetchNotifications: () => dispatch(getNotificationsList()),
  onMarkNotificationRead: id => dispatch(markNotificationAsRead(id)),
  onGetNotificationPreference: () => dispatch(getNotificationPreference()),
  onUpdateNotificationPreference: params => dispatch(updateNotificationPreference(params)),
  onMarkAllNotificationsAsRead: () => dispatch(markAllNotificationsAsRead()),
  onCreateSpacePost: (apiParams, spaceId) => dispatch(createSpacePost(apiParams, spaceId)),
  onSubscriptionPermissionRequest: type => dispatch(subscriptionPermissionRequest(type)),
  onAdvancedSearch: (params) => dispatch(advancedSearch(params)),
  onSetElephantVerificationModal: (params) => dispatch(setElephantVerificationModal(params)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(FavouritePage);
